module.exports = __webpack_public_path__ + "static/media/banner_img@2x.a5ab57f7.png";